import LineAirConditioningIcon from 'LuxKit/Icons/line/LineAirConditioningIcon'
import LineAppleIcon from 'LuxKit/Icons/line/LineAppleIcon'
import LineBalconyIcon from 'LuxKit/Icons/line/LineBalconyIcon'
import LineBathIcon from 'LuxKit/Icons/line/LineBathIcon'
import LineBedDoubleAltIcon from 'LuxKit/Icons/line/LineBedDoubleAltIcon'
import LineBedDoubleIcon from 'LuxKit/Icons/line/LineBedDoubleIcon'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import LineBedKingIcon from 'LuxKit/Icons/line/LineBedKingIcon'
import LineBedQueenIcon from 'LuxKit/Icons/line/LineBedQueenIcon'
import LineBedSingleIcon from 'LuxKit/Icons/line/LineBedSingleIcon'
import LineBedSofaIcon from 'LuxKit/Icons/line/LineBedSofaIcon'
import LineBellIcon from 'LuxKit/Icons/line/LineBellIcon'
import LineBlenderIcon from 'LuxKit/Icons/line/LineBlenderIcon'
import LineBooksIcon from 'LuxKit/Icons/line/LineBooksIcon'
import LineBoxIcon from 'LuxKit/Icons/line/LineBoxIcon'
import LineBriefcaseIcon from 'LuxKit/Icons/line/LineBriefcaseIcon'
import LineBusIcon from 'LuxKit/Icons/line/LineBusIcon'
import LineCarIcon from 'LuxKit/Icons/line/LineCarIcon'
import LineChairWithAirplaneIcon from 'LuxKit/Icons/line/LineChairWithAirplaneIcon'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import LineChildWithPlusIcon from 'LuxKit/Icons/line/LineChildWithPlusIcon'
import LineClochIcon from 'LuxKit/Icons/line/LineClochIcon'
import LineClockWithTickIcon from 'LuxKit/Icons/line/LineClockWithTickIcon'
import LineCoffeeIcon from 'LuxKit/Icons/line/LineCoffeeIcon'
import LineCookingPanIcon from 'LuxKit/Icons/line/LineCookingPanIcon'
import LineDelayIcon from 'LuxKit/Icons/line/LineDelayIcon'
import LineDesktopIcon from 'LuxKit/Icons/line/LineDesktopIcon'
import LineDiamondIcon from 'LuxKit/Icons/line/LineDiamondIcon'
import LineDiningCreditIcon from 'LuxKit/Icons/line/LineDiningCreditIcon'
import LineDollarSignIcon from 'LuxKit/Icons/line/LineDollarSignIcon'
import LineDoorIcon from 'LuxKit/Icons/line/LineDoorIcon'
import LineDrinksTrayIcon from 'LuxKit/Icons/line/LineDrinksTrayIcon'
import LineDryerIcon from 'LuxKit/Icons/line/LineDryerIcon'
import LineDumbbellIcon from 'LuxKit/Icons/line/LineDumbbellIcon'
import LineExcursionIcon from 'LuxKit/Icons/line/LineExcursionIcon'
import LineExerciseBikeIcon from 'LuxKit/Icons/line/LineExerciseBikeIcon'
import LineFamilyIcon from 'LuxKit/Icons/line/LineFamilyIcon'
import LineFireIcon from 'LuxKit/Icons/line/LineFireIcon'
import LineFlightCreditIcon from 'LuxKit/Icons/line/LineFlightCreditIcon'
import LineFlowerIcon from 'LuxKit/Icons/line/LineFlowerIcon'
import LineFridgeIcon from 'LuxKit/Icons/line/LineFridgeIcon'
import LineGameStructureIcon from 'LuxKit/Icons/line/LineGameStructureIcon'
import LineGlassIcon from 'LuxKit/Icons/line/LineGlassIcon'
import LineGlassMartiniAltIcon from 'LuxKit/Icons/line/LineGlassMartiniAltIcon'
import LineGlassMartiniIcon from 'LuxKit/Icons/line/LineGlassMartiniIcon'
import LineGolfIcon from 'LuxKit/Icons/line/LineGolfIcon'
import LineGrapesIcon from 'LuxKit/Icons/line/LineGrapesIcon'
import LineHairDryerIcon from 'LuxKit/Icons/line/LineHairDryerIcon'
import LineHammockIcon from 'LuxKit/Icons/line/LineHammockIcon'
import LineHappyHourIcon from 'LuxKit/Icons/line/LineHappyHourIcon'
import LineHeartIcon from 'LuxKit/Icons/line/LineHeartIcon'
import LineIronIcon from 'LuxKit/Icons/line/LineIronIcon'
import LineKayakIcon from 'LuxKit/Icons/line/LineKayakIcon'
import LineKettleIcon from 'LuxKit/Icons/line/LineKettleIcon'
import LineKeySkeletonAltIcon from 'LuxKit/Icons/line/LineKeySkeletonAltIcon'
import LineKidIcon from 'LuxKit/Icons/line/LineKidIcon'
import LineLandmarkIcon from 'LuxKit/Icons/line/LineLandmarkIcon'
import LineLockIcon from 'LuxKit/Icons/line/LineLockIcon'
import LineMicrowaveIcon from 'LuxKit/Icons/line/LineMicrowaveIcon'
import LineMountainsRoadIcon from 'LuxKit/Icons/line/LineMountainsRoadIcon'
import LineMusicIcon from 'LuxKit/Icons/line/LineMusicIcon'
import LineNoFeesIcon from 'LuxKit/Icons/line/LineNoFeesIcon'
import LineOneWayFlightIcon from 'LuxKit/Icons/line/LineOneWayFlightIcon'
import LineOvenIcon from 'LuxKit/Icons/line/LineOvenIcon'
import LineParkingCircleIcon from 'LuxKit/Icons/line/LineParkingCircleIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import LinePoolTableIcon from 'LuxKit/Icons/line/LinePoolTableIcon'
import LinePricetagAltIcon from 'LuxKit/Icons/line/LinePricetagAltIcon'
import LineReceiptIcon from 'LuxKit/Icons/line/LineReceiptIcon'
import LineReturnFlightIcon from 'LuxKit/Icons/line/LineReturnFlightIcon'
import LineRoomUpgradeIcon from 'LuxKit/Icons/line/LineRoomUpgradeIcon'
import LineSanitizerIcon from 'LuxKit/Icons/line/LineSanitizerIcon'
import LineSaunaIcon from 'LuxKit/Icons/line/LineSaunaIcon'
import LineSceneryIcon from 'LuxKit/Icons/line/LineSceneryIcon'
import LineShipIcon from 'LuxKit/Icons/line/LineShipIcon'
import LineShopIcon from 'LuxKit/Icons/line/LineShopIcon'
import LineShowerIcon from 'LuxKit/Icons/line/LineShowerIcon'
import LineSightseeingIcon from 'LuxKit/Icons/line/LineSightseeingIcon'
import LineSkiLiftIcon from 'LuxKit/Icons/line/LineSkiLiftIcon'
import LineSnowFlakeIcon from 'LuxKit/Icons/line/LineSnowFlakeIcon'
import LineSpaCreditIcon from 'LuxKit/Icons/line/LineSpaCreditIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LineSunIcon from 'LuxKit/Icons/line/LineSunIcon'
import LineSwimmerIcon from 'LuxKit/Icons/line/LineSwimmerIcon'
import LineTagIcon from 'LuxKit/Icons/line/LineTagIcon'
import LineTaxiIcon from 'LuxKit/Icons/line/LineTaxiIcon'
import LineTennisBallIcon from 'LuxKit/Icons/line/LineTennisBallIcon'
import LineTheatreIcon from 'LuxKit/Icons/line/LineTheatreIcon'
import LineTicketIcon from 'LuxKit/Icons/line/LineTicketIcon'
import LineToasterIcon from 'LuxKit/Icons/line/LineToasterIcon'
import LineTowelIcon from 'LuxKit/Icons/line/LineTowelIcon'
import LineTreesIcon from 'LuxKit/Icons/line/LineTreesIcon'
import LineTvRetroIcon from 'LuxKit/Icons/line/LineTvRetroIcon'
import LineUmbrellaIcon from 'LuxKit/Icons/line/LineUmbrellaIcon'
import LineUniversityIcon from 'LuxKit/Icons/line/LineUniversityIcon'
import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'
import LineUtensilsIcon from 'LuxKit/Icons/line/LineUtensilsIcon'
import LineWalkingIcon from 'LuxKit/Icons/line/LineWalkingIcon'
import LineWashingMachineIcon from 'LuxKit/Icons/line/LineWashingMachineIcon'
import LineWaterIcon from 'LuxKit/Icons/line/LineWaterIcon'
import LineWatersportsIcon from 'LuxKit/Icons/line/LineWatersportsIcon'
import LineWellnessIcon from 'LuxKit/Icons/line/LineWellnessIcon'
import LineWheelchairIcon from 'LuxKit/Icons/line/LineWheelchairIcon'
import LineWifiIcon from 'LuxKit/Icons/line/LineWifiIcon'
import LineWifiRouterIcon from 'LuxKit/Icons/line/LineWifiRouterIcon'
import LineWindIcon from 'LuxKit/Icons/line/LineWindIcon'
import LineWineBeerIcon from 'LuxKit/Icons/line/LineWineBeerIcon'
import SolidKeySkeletonAltIcon from 'LuxKit/Icons/solid/SolidKeySkeletonAltIcon'
import type SvgIcon from 'LuxKit/SvgIcon'
import switchFunc from 'lib/function/switchFunc'

export const ICONS: Record<App.Property.IconName, typeof SvgIcon> = {
  line_air_conditioning: LineAirConditioningIcon,
  line_apple: LineAppleIcon,
  line_balcony: LineBalconyIcon,
  line_bath: LineBathIcon,
  line_bed: LineBedIcon,
  line_bed_double: LineBedDoubleIcon,
  line_bed_double_alt: LineBedDoubleAltIcon,
  line_bed_king: LineBedKingIcon,
  line_bed_queen: LineBedQueenIcon,
  line_bed_single: LineBedSingleIcon,
  line_bed_sofa: LineBedSofaIcon,
  line_bell: LineBellIcon,
  line_blender: LineBlenderIcon,
  line_books: LineBooksIcon,
  line_box: LineBoxIcon,
  line_briefcase: LineBriefcaseIcon,
  line_bus: LineBusIcon,
  line_car: LineCarIcon,
  line_chair_with_airplane: LineChairWithAirplaneIcon,
  line_check: LineCheckIcon,
  line_child_with_plus: LineChildWithPlusIcon,
  line_cloch: LineClochIcon,
  line_clock_with_tick: LineClockWithTickIcon,
  line_coffee: LineCoffeeIcon,
  line_cooking_pan: LineCookingPanIcon,
  line_delay: LineDelayIcon,
  line_desktop: LineDesktopIcon,
  line_diamond: LineDiamondIcon,
  line_dining_credit: LineDiningCreditIcon,
  line_dollar_sign: LineDollarSignIcon,
  line_door: LineDoorIcon,
  line_drinks_tray: LineDrinksTrayIcon,
  line_dryer: LineDryerIcon,
  line_dumbbell: LineDumbbellIcon,
  line_excursion: LineExcursionIcon,
  line_exercise_bike: LineExerciseBikeIcon,
  line_family: LineFamilyIcon,
  line_fire: LineFireIcon,
  line_flight_credit: LineFlightCreditIcon,
  line_flower: LineFlowerIcon,
  line_fridge: LineFridgeIcon,
  line_game_structure: LineGameStructureIcon,
  line_glass: LineGlassIcon,
  line_glass_martini: LineGlassMartiniIcon,
  line_glass_martini_alt: LineGlassMartiniAltIcon,
  line_golf: LineGolfIcon,
  line_grapes: LineGrapesIcon,
  line_hair_dryer: LineHairDryerIcon,
  line_hammock: LineHammockIcon,
  line_happy_hour: LineHappyHourIcon,
  line_heart: LineHeartIcon,
  line_iron: LineIronIcon,
  line_kayak: LineKayakIcon,
  line_kettle: LineKettleIcon,
  line_key_skeleton_alt: LineKeySkeletonAltIcon,
  line_kid: LineKidIcon,
  line_landmark: LineLandmarkIcon,
  line_lock: LineLockIcon,
  line_microwave: LineMicrowaveIcon,
  line_mountains_road: LineMountainsRoadIcon,
  line_music: LineMusicIcon,
  line_no_fees: LineNoFeesIcon,
  line_one_way_flight: LineOneWayFlightIcon,
  line_oven: LineOvenIcon,
  line_parking_circle: LineParkingCircleIcon,
  line_plane_departure: LinePlaneDepartureIcon,
  line_pool_table: LinePoolTableIcon,
  line_pricetag_alt: LinePricetagAltIcon,
  line_receipt: LineReceiptIcon,
  line_return_flight: LineReturnFlightIcon,
  line_room_upgrade: LineRoomUpgradeIcon,
  line_sanitizer: LineSanitizerIcon,
  line_sauna: LineSaunaIcon,
  line_scenery: LineSceneryIcon,
  line_ship: LineShipIcon,
  line_shop: LineShopIcon,
  line_shower: LineShowerIcon,
  line_sightseeing: LineSightseeingIcon,
  line_ski_lift: LineSkiLiftIcon,
  line_snow_flake: LineSnowFlakeIcon,
  line_spa_credit: LineSpaCreditIcon,
  line_star: LineStarIcon,
  line_sun: LineSunIcon,
  line_swimmer: LineSwimmerIcon,
  line_tag: LineTagIcon,
  line_taxi: LineTaxiIcon,
  line_tennis_ball: LineTennisBallIcon,
  line_theatre: LineTheatreIcon,
  line_ticket: LineTicketIcon,
  line_toaster: LineToasterIcon,
  line_towel: LineTowelIcon,
  line_trees: LineTreesIcon,
  line_tv_retro: LineTvRetroIcon,
  line_umbrella: LineUmbrellaIcon,
  line_university: LineUniversityIcon,
  line_usd_circle: LineUsdCircleIcon,
  line_utensils: LineUtensilsIcon,
  line_walking: LineWalkingIcon,
  line_washing_machine: LineWashingMachineIcon,
  line_water: LineWaterIcon,
  line_watersports: LineWatersportsIcon,
  line_wellness: LineWellnessIcon,
  line_wheelchair: LineWheelchairIcon,
  line_wifi: LineWifiIcon,
  line_wifi_router: LineWifiRouterIcon,
  line_wind: LineWindIcon,
  line_wine_beer: LineWineBeerIcon,
  solid_key_skeleton_alt: SolidKeySkeletonAltIcon,
}

const iconsSwitch = switchFunc(ICONS, LineCheckIcon)

export default function getPropertyIcon(iconName: App.Property.IconName | undefined): typeof SvgIcon {
  return iconsSwitch(iconName ?? '')
}
